import {BuildGameConfigurations} from '@colonist/game-base-types'
import {UIWGameTradeCreationController} from './ui_game_trade/UIWGameTradeCreationController'
import {UIAdController} from '../../../shared/scripts/ui_ad/UIAdController'
import {UIWGameBankController} from './UIWGameBankController'
import {UIWGameCanvasController} from './UIWGameCanvasController'
import {UIGameManager} from '../../../shared/scripts/ui_game/UIGameManager'
import {UIWGameStateController} from './UIWGameStateController'
import {UIWGameTimerController} from './UIWGameTimerController'
import {UIWGameActionsController} from './ui_game_action/UIWGameActionsController'
import {UIWGameCardController} from './ui_game_card/UIWGameCardController'
import {UIWGameMapController} from './ui_game_map/UIWGameMapController'
import {UIWGamePlayersController} from './ui_game_players/UIWGamePlayersController'
import {UIWGameToolTipController} from './ui_game_tooltip/UIWGameToolTipController'
import {UIWGameVoteController} from './ui_game_vote/UIWGameVoteController'
import {UIWGameBaseDiceController} from './ui_game_dice/UIWGameBaseDiceController'
import {UIWGameAchievementController} from './ui_game_achievement/UIWGameAchievementController'
import {UIWGameHelpButtonsController} from './ui_game_help_buttons/UIWGameHelpButtonsController'
import {UIGameTurnSoundController} from '../../../shared/scripts/ui_game/UIGameTurnSoundController'
import {UIWGamePopupController} from './ui_game_popup/UIWGamePopupController'
import {UIWGamePauseController} from './UIWGamePauseController'
import {UIGameSettingsAudioShortcuts} from '../../../shared/scripts/ui_game/ui_game_settings/ui_game_settings_audio/UIGameSettingsAudioShortcuts'
import {UIWGamePlayerInformationArrayController} from './ui_game_players/UIWGamePlayerInformationArrayController'
import {UIWGamePlayerInformationProgressCardController} from './ui_game_players/UIWGamePlayerInformationProgressCardController'
import {UIWGamePlayerInformationLongestRoadController} from './ui_game_players/UIWGamePlayerInformationLongestRoadController'
import {UIWGamePlayerInformationLargestArmyController} from './ui_game_players/UIWGamePlayerInformationLargestArmyController'
import {UIWGameInventorHighlightDiceController} from './ui_game_map/UIWGameInventorHighlightDiceController'
import {UIWGameEventDiceController} from './ui_game_cities_and_knights/ui_game_cities_and_knights_dice/UIWGameEventDiceController'
import {UIWGameBarbarianInvasion} from './ui_game_cities_and_knights/UIWGameBarbarianInvasion'
import {UIWGameCityImprovement} from './ui_game_cities_and_knights/UIWGameCityImprovement'
import {UIWGameKnightController} from './ui_game_cities_and_knights/UIWGameKnightController'
import {UIWGameMapCityWallController} from './ui_game_map/UIWGameMapCityWallController'
import {UIGameFogTileController} from '../../../shared/scripts/ui_game/ui_game_map/UIGameFogTileController'
import {UIGameGoldTileController} from '../../../shared/scripts/ui_game/ui_game_map/UIGameGoldTileController'
import {UIWGameMapShipController} from './ui_game_map/UIWGameMapShipController'
import {UIGameMapPirateController} from '../../../shared/scripts/ui_game/ui_game_map/UIGameMapPirateController'
import {UIWGameSpecialBuildPhaseButtonController} from './ui_game_special_build_phase/UIWGameSpecialBuildPhaseButtonController'
import {UIGameMapChitController} from '../../../shared/scripts/ui_game/ui_game_map/UIGameMapChitController'
import {UIWGameLayout} from './UIWGameLayout'
import {UIGameController} from '../../../shared/scripts/ui_game/UIGameController'
import {UIGameTradeOffersController} from '../../../shared/scripts/trade/ui_trade_offers/UIGameTradeOffersController'
import {UIGameMerchantController} from '../../../shared/scripts/ui_game/ui_game_map/UIGameMapMerchantController'
import {GameState, NestedReadonly} from '@colonist/game-states'
import {UIGameMapRobberController} from '../../../shared/scripts/ui_game/ui_game_map/UIGameMapRobberController'
import {UIWGameTabVisibilityController} from '../../../../client/web/scripts/ui_game/UIWGameTabVisibilityController'
import {renderUIGame} from '@colonist/ui-game'
import {UIReplayController} from '../../../shared/scripts/ui_replay/UIReplayController'
import {UIWReplayView} from './UIWReplayView'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {UIGameActionSuggestionController} from '../../../shared/scripts/ui_game/ui_game_actions/UIGameActionSuggestionController'

export class UIWGameManager extends UIGameManager {
    constructor(adController?: UIAdController) {
        super(adController)

        this.canvasController = new UIWGameCanvasController(this)
        this.toolTipController = new UIWGameToolTipController(this)
    }

    buildGame(configurations: BuildGameConfigurations) {
        this.gameController = new UIGameController(this, configurations)

        renderUIGame({
            gameManager: this,
            initialUserStates: configurations.playerUserStates,
            initialGameState: configurations.gameState,
            options: {
                isChatEnabled: !UIUtilsEjsVariables.isUserOnDiscordMobile,
            },
            gameSettings: configurations.gameSettings,
        })

        new UIWGameTabVisibilityController(this)

        const {
            tradeState,
            mechanicDevelopmentCardsState,
            mechanicProgressCardsState,
            mechanicSettlementState,
            mechanicCityState,
            mechanicCityWallState,
            mechanicCityImprovementsState,
            mechanicRoadState,
            mechanicLongestRoadState,
            mechanicLargestArmyState,
            mechanicSpecialBuildPhaseState,
            mechanicRobberState,
            mechanicEventDiceState,
        } = configurations.gameState

        this.gameLayout = new UIWGameLayout(this)
        this.mapController = new UIWGameMapController(this) // Jan 28, 2021. Jeff: Map first so its below containers
        this.bankController = new UIWGameBankController(this, mechanicDevelopmentCardsState, mechanicProgressCardsState)
        this.playersController = new UIWGamePlayersController(this,
            mechanicDevelopmentCardsState,
            mechanicProgressCardsState,
            mechanicSettlementState,
            mechanicCityState,
            mechanicCityWallState,
            mechanicCityImprovementsState,
            mechanicRoadState,
            mechanicLongestRoadState,
            mechanicLargestArmyState,
            mechanicSpecialBuildPhaseState)
        this.actionsController = new UIWGameActionsController(this, mechanicSettlementState, mechanicCityState, mechanicRoadState)
        this.voteController = new UIWGameVoteController(this)
        this.cardController = new UIWGameCardController(this, mechanicRobberState)
        this.timerController = new UIWGameTimerController(this)
        this.diceController = new UIWGameBaseDiceController(this, mechanicEventDiceState)
        new UIGameTradeOffersController(this, tradeState.activeOffers)
        new UIWGameStateController(this)
        new UIWGameAchievementController(this)
        new UIWGameHelpButtonsController(this)
        new UIGameTurnSoundController(this)
        new UIWGamePopupController(this, mechanicProgressCardsState)
        new UIGameActionSuggestionController(this, mechanicDevelopmentCardsState, mechanicProgressCardsState)
        if(!this.gameController.isPlayerSpectator) this.tradeController = new UIWGameTradeCreationController(this)
        this.pauseController = new UIWGamePauseController(this)

        new UIGameSettingsAudioShortcuts(this)
        new UIGameGoldTileController(this)
        this.buildOrderDependentControllers(configurations.gameState)
    }

    // eslint-disable-next-line class-methods-use-this
    buildGameFeed(): void {
        return
    }

    buildReplayView(replayController: UIReplayController): void {
        const useMinimalReplayControls = UIUtilsEjsVariables.isUserOnMobile
        this.replayView = new UIWReplayView(replayController, useMinimalReplayControls)
    }

    private buildOrderDependentControllers(gameState: NestedReadonly<GameState>) {
        this.mapController.createMap()
        this.buildOptionalMechanics(gameState)
        this.actionsController.buildButtonController()
        this.mapController.mapView.sortChildren()
        if(this.originalMapPosition != undefined) {
            this.mapController.mapView.scale.set(this.originalMapPosition.zoom.x, this.originalMapPosition.zoom.y)
            this.mapController.mapView.emit('zoomed', this.mapController.mapView.DEFAULT_ZOOM_EVENT)
            this.mapController.mapView.repositionMap(this.originalMapPosition.location)
        }
    }

    protected buildOptionalMechanics(gameState: NestedReadonly<GameState>) {
        if(gameState.mechanicDevelopmentCardsState) {
            this.actionsController.activateBuyDevelopmentCardButton(gameState.mechanicDevelopmentCardsState)
        }

        if(gameState.mechanicCityWallState) {
            new UIWGameMapCityWallController(this, gameState.mechanicCityWallState)
        }

        if(gameState.mechanicShipState) {
            new UIWGameMapShipController(this, gameState.mechanicShipState, gameState.mechanicPirateState)
        }

        if(gameState.mechanicLongestRoadState) {
            new UIWGamePlayerInformationLongestRoadController(this, gameState.mechanicLongestRoadState)
        }

        if(gameState.mechanicLargestArmyState) {
            new UIWGamePlayerInformationLargestArmyController(this, gameState.mechanicLargestArmyState)
        }

        if(gameState.mechanicRobberState) {
            new UIGameMapRobberController(this, gameState.mechanicRobberState)
        }

        if(gameState.mechanicPirateState) {
            new UIGameMapPirateController(this, gameState.mechanicPirateState)
        }

        if(gameState.mechanicEventDiceState) {
            new UIWGameEventDiceController(this, gameState.mechanicEventDiceState)
        }

        if(gameState.mechanicSpecialBuildPhaseState) {
            new UIWGameSpecialBuildPhaseButtonController(this, gameState.mechanicSpecialBuildPhaseState)
        }

        if(gameState.mechanicIslandExplorationState) {
            new UIGameMapChitController(this)
        }

        if(gameState.mapState.fogTileGroupStates) {
            new UIGameFogTileController(this, gameState.mapState.fogTileGroupStates)
        }

        if(gameState.mechanicKnightState) {
            new UIWGameKnightController(this, gameState.mechanicKnightState, gameState.mechanicRobberState, gameState.mechanicPirateState)
        }

        if(gameState.mechanicMerchantState) {
            new UIGameMerchantController(this, gameState.mechanicMerchantState)
        }

        if(gameState.mechanicBarbarianInvasionState && gameState.mechanicKnightState) {
            new UIWGameBarbarianInvasion(this, gameState.mechanicBarbarianInvasionState, gameState.mechanicKnightState)
        }

        if(gameState.mechanicKnightState) {
            new UIWGamePlayerInformationArrayController(this)
        }

        if(gameState.mechanicProgressCardsState) {
            new UIWGamePlayerInformationProgressCardController(this)
            new UIWGameInventorHighlightDiceController(this)
        }

        if(gameState.mechanicCityImprovementsState) {
            new UIWGameCityImprovement(this, gameState.mechanicCityImprovementsState, gameState.mechanicRobberState)
        }

        super.buildOptionalMechanics(gameState)
    }
}
